import { FC } from 'react'
import helpers from 'workflow/utils/helpers'

import GuidingText from 'common/components/guidingText'

import CreatableSelect, { getOptionsArray, Options } from './CreatableSelect'

const { isValidEmail } = helpers

export type EmailOptions = Options

interface Props {
  values: Options
  setValues: (val: Options) => void
  options?: Options
}

const EmailsSelect: FC<Props> = (props) => {
  return (
    <>
      <CreatableSelect
        data-cy="select-emails"
        data-testid="select-emails"
        ariaLabel="Select emails"
        isValidNewOption={(value: string) =>
          getOptionsArray(value).every((option) => isValidEmail(option))
        }
        {...props}
      />
      <GuidingText text="To send to multiple email address, separate them by using a comma." />
    </>
  )
}

export default EmailsSelect
